import { Button } from '@creditornot/cb-button';
import { ModalContent, ModalFooter, ModalHeader } from '@creditornot/cbt-modal';
import React from 'react';
import { Field, Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

import { SupportableReportMetric } from './types';
import CustomSelect from '../../core/CustomSelect';
import { ReportMetricForm } from '../../types';

type MetricsModalContentFormProps = {
  selectedMetrics: string[];
  supportedMetrics: SupportableReportMetric[];
  onUpdate: (values: ReportMetricForm) => void;
  onClose: () => void;
};

const StyledCheckboxGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media (width < ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 1fr;
  }
`;

const StyledModalFooter = styled(ModalFooter)`
  display: flex;
  justify-content: flex-end;
`;

export const MetricsModalContentForm = ({
  supportedMetrics,
  selectedMetrics,
  onUpdate,
  onClose,
}: MetricsModalContentFormProps) => {
  return (
    <Form<ReportMetricForm> onSubmit={values => onUpdate(values)} initialValues={{ metrics: selectedMetrics }}>
      {({ handleSubmit }) => (
        <>
          <ModalHeader onCloseClick={onClose}>
            {/* TODO: @navjotahuja92 Figure out how to wrap this in heading6  as new ModalHeader throws an error */}
            <FormattedMessage id="insights.reports.data-options.select" />
          </ModalHeader>
          <ModalContent>
            <StyledCheckboxGroup>
              {supportedMetrics.map(metric => (
                <Field<string> name="metrics" type="checkbox" value={metric.id} key={metric.id}>
                  {({ input }) => (
                    <CustomSelect
                      {...input}
                      customSelectType="checkbox"
                      inputProps={{
                        disabled: !metric.isSupported,
                      }}
                    >
                      <Typography.Body3>{metric.name}</Typography.Body3>
                    </CustomSelect>
                  )}
                </Field>
              ))}
            </StyledCheckboxGroup>
          </ModalContent>
          <StyledModalFooter>
            <Button variant="blue" size="small" onClick={handleSubmit}>
              <FormattedMessage id="insights.reports.data-options.save" />
            </Button>
          </StyledModalFooter>
        </>
      )}
    </Form>
  );
};
